import Vue from 'vue'
import { JSEncrypt } from 'jsencrypt'
// 加密方法  公钥
Vue.prototype.$getCode = function (password) {
    const publicKey = `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAqJhI8DOgaKMVOvHgU+Mq
    JLmom+An7LEnTaNO3iJN7G3K/yKWKNn3DA3M5dDxn8NW22FKee2RBjP/fUlSbmZ9
    epoR67ZqMiolW2VVMVEI2Td0o4FElc9LADMxopdfZJmxu5oJlfRA6cuBsRs52hKE
    xb+MKfb/ES4yYlw2lqKyvPssy7IwVIB+KPn35lb8J2KnOqnNlJ1USO0ezVCMIsKI
    H0MnOxODlkoADBsQMKfOQP4QXzzj4w0LnBWgIYQVx6CLWh/7eWQG5K2ecH3RCG3E
    z781y+vh8olNSuEZD+qSJl3bNSRR8wepzHpZuu79yEbYGY2xrhJTHhC2Y7eEAaxq
    LQIDAQAB`
    const encrypt = new JSEncrypt()
    encrypt.setPublicKey(publicKey)
    const data = encrypt.encrypt(password)
    return data
   }
//    解密方法 私钥
   Vue.prototype.$decryptCode = function (password) {
    const privateKey = `MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQDUhAd9Cw0XApYS
4f/ZcZtZq4HxXGfsUMcIwxV79/q5fh0cLYGSCoopEDk6LP9B5xqOqW6DL1MtiXZN
Z4QaqF6q77cgeGRsBcL1frAHovqwdddYtzC/BKVT1PzO0chtFunRLvGrm8KuzwFT
aZDLXY5qZDuIK1k4zaDUn/bKyB207L+dAA0zLud9tEnIXPicDUvOK5VMTwXJizMa
WSxdGl0KBR9jrwWVYTxeiOQ9n9Bvv4Zj6MZzL/14RFUyXXor16/IAB16CDH/ESa7
AWT5gVSVgQYvNlALotI8vq0W3PyNvCyiQZSaX48/lE4SRjy1tzb4ORVBobQkKwcK
1jp+scafAgMBAAECggEANZuol+51utw4J0NDWwLBgXk2KkB5Jq+pxZgQj1kasjgR
982y5bgq6fjhtr8rFODLXjl3WzhQ7yfB4/y84kyetNgLhfFYw7cgWvU+Sm7edi0D
yalMbqMpYWBU9YcN3BbvnIkPBY8hKR+m4fe7QtGy3zuxmMP2mdGlRH2lr7mTZNPu
AyA6ZZvQ8dC7xxNCKkiXNy0vacbp51j48bgYgVUTFXX73k1UQsFdZbqW8jUyGRpN
mw9rOoVLSyGRmUxWh+++D6TZXjHsdXKaY2CHB/7YFxLFFYwGv3Z9hvxutsxkN8dJ
Dfb9XG0xaosfgEbkbDSxpR9BtKsanAjsJwccCOTYgQKBgQD5KxYYBDemcdSy2OUo
WhCARGC3qclhQxFPreGtiv59cJ3s55yayr+1r/X40X9/Hscdc82+MXfBJ72BAPzy
UpHlHYuz+QFojxnhULFfV7VZxToyR52KkE9VSYuzeE7jkoIpfVqt+efWJpy7Vg3p
fc4O83aRnEYEZjVo2FKkIzsRTwKBgQDaV62qhEkZkKXWHh/G4YDkEf5MVqu9szbt
G08DiX18NRrdrwfJICVFaSOKSY+ukCS3pKVvDEHG/iHqogRNzmXYjM1Xzcgfuu2s
RIuyARgab3s6Gf/GG+sqPJF4TK8A0mpf+Tu1NRXUG49raY3qfbNNJ55MFiOkPAP8
OUbmcj6BsQKBgQCz4bAsnHbUmd81UrJ1ZDf/cd3lGhVBO1r3DBAd6nd5deD9U+RS
N8cZUrQf8pa53i1fjOfew/Wxo5AC3wS9qHCdWKwvvLeQlabYbBnxO++3pFQ0UlFg
5HfxmYvagCNr1axUaaQab404pF2IPUMD6wfk8U0LKCfAK02pqGpZBvowrwKBgB1I
4TwbngpVwkhjpfNwz27Hkwn+He7FmLpYjVJ2IGSGYuIU1cB+FUGoBmJH14OcRbBz
3tR0GmZsM3Ra4qTk5/gReoEqUose8T3Hu8zWJLt29Foonoudtv7lPMWb02US072n
mgCF7DWUtLm9YJFw5pmUlMCzv3gJrKcpr369F/EhAoGAXiNJNwM2f6eKb+i31x80
610nYmhb4ZpwODGgXDxnLEDQS1fMETmbRfnIVjeVgQggWK/UpYJYOqjHwWMc0fLx
XM8+RZCBXHigFWuMaLlZlTDU2dOxipN4fdVmrqbKfjbeRDOlc2ggk5jLDxOP+2jD
+peRjeLxWtAJuB1TPk7UXOU=`
    const encrypt = new JSEncrypt()
    encrypt.setPublicKey(privateKey)
    const data = encrypt.decrypt(password)
    return data
   }
   //
